import styled from 'styled-components';

export const SpanBadge = styled.span`
  &.badge-danger {
    color: #2e3338;
  }
  &.badge-warning {
    color: #2e3338;
  }
  &.badge-success {
    color: #2e3338;
  }
  &.badge-orange {
    color: #2e3338;
    background-color: #db8b2e !important;
  }
`;
